import { render, staticRenderFns } from "./ndr_mr.vue?vue&type=template&id=08a9d0e9"
import script from "./ndr_mr.vue?vue&type=script&lang=js"
export * from "./ndr_mr.vue?vue&type=script&lang=js"
import style0 from "./ndr_mr.vue?vue&type=style&index=0&id=08a9d0e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports